import React from "react";
import { LinearProgress } from "@mui/material"

export const ApiProgress = () => {
    return (<LinearProgress />)
};